import { CSSProperties } from 'react';
import { IRequestedStudy } from '@vivli/features/data-requests/infrastructure/interface';
import { useAdminConsoleContext } from '@vivli/features/admin-console/infrastructure/context';
import { ButtonView, LoadIndicatorView } from '@vivli/shared/views';

const gridButtonStyle: CSSProperties = {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexDirection: 'row',
    flexWrap: 'wrap',
};
const marginRightBrnStyle = {
    marginRight: 10,
    marginBottom: 10,
};
export const RequestedStudyStatusButtonsRendererComponent = ({ data }: { data: IRequestedStudy }) => {
    const context = useAdminConsoleContext();
    const btnClick = (study: IRequestedStudy, action: string) => {
        context.handleAction(action, study.requestId, study.studyId, action == 'CopyRequestedFilesFromStudy');
    };

    return (
        <div>
            {context.isLoading && <LoadIndicatorView />}
            {!context.isLoading && (
                <div style={gridButtonStyle}>
                    <ButtonView onClick={() => btnClick(data, 'ResetRequestedStudyToNew')} style={marginRightBrnStyle}>
                        Reset Status to New
                    </ButtonView>
                    <ButtonView onClick={() => btnClick(data, 'ResetRequestedStudyToIPDProvided')} style={marginRightBrnStyle}>
                        Reset Status to IPDProvided
                    </ButtonView>
                    <ButtonView onClick={() => btnClick(data, 'ResetRequestedStudyLinkToIPD')} style={marginRightBrnStyle}>
                        Reset link to study latest IPD
                    </ButtonView>
                    <ButtonView onClick={() => btnClick(data, 'RemoveRequestedStudyFiles')} style={marginRightBrnStyle}>
                        Remove Requested Study Files
                    </ButtonView>
                    <ButtonView onClick={() => btnClick(data, 'CopyRequestedFilesFromStudy')} style={marginRightBrnStyle}>
                        Copy Requested Files from Study
                    </ButtonView>
                </div>
            )}
        </div>
    );
};
